import i18n from "i18next"

import { MENU } from "@/utils/constants/menu"

/**
 * Generate the menu items for the sidebar
 * @param {string} menuName - The name of the menu to generate
 * @param {string} organizationId - The ID of the organization
 * @param {string} siteId - The ID of the site
 * @returns {Array} - The menu items
 */
const menu = (menuName, organizationId = null, siteId = null) => {
  let items = []

  switch (menuName) {
    case MENU.HOME:
      items = [
        {
          slug: "sites",
          label: i18n.t("common.sites"),
          icon: "fa-solid fa-city",
          namespace: "/map",
          url: "/",
          disabled: false,
          visible: true
        },
        {
          slug: "organizations",
          label: i18n.t("common.organizations"),
          icon: "fa-solid fa-city",
          namespace: "/organizations/",
          url: "/organizations/",
          disabled: false,
          visible: true
        }
      ]
      break

    case MENU.PARAMETERS:
      items = [
        {
          slug: "configuration.gateways",
          label: i18n.t("common.gateways"),
          icon: "fa-solid fa-microchip",
          url: "/configuration/gateways/beebryte/",
          namespace: "/configuration/gateways/",
          disabled: false,
          visible: true
        },
        {
          slug: "configuration.parameters",
          label: i18n.t("common.units_and_quantities"),
          icon: "fa-solid fa-sliders",
          url: "/configuration/units-and-quantities/",
          disabled: false,
          visible: true
        },
        {
          slug: "configuration.equipment_type",
          label: i18n.t("common.equipment_type"),
          icon: "fa-solid fa-plug",
          url: "/configuration/equipment-types/",
          disabled: false,
          visible: true
        }
      ]
      break

    case MENU.ORGANIZATIONS:
      // If the organization ID is provided,
      // generate the menu items for the organization
      if (organizationId) {
        items = [
          {
            slug: "sites",
            label: i18n.t("common.sites"),
            icon: "fa-solid fa-city",
            url: `/organizations/${organizationId}/sites/`,
            disabled: false,
            visible: true
          }
        ]
      }

    case MENU.SITE:
      // If the site ID is provided,
      // generate the menu items for the site
      if (siteId) {
        items = [
          {
            slug: "assets",
            label: i18n.t("common.assets"),
            icon: "fa-solid fa-network-wired",
            url: `/organizations/${organizationId}/sites/${siteId}/assets/`,
            namespace: `/organizations/${organizationId}/sites/${siteId}/assets/`,
            disabled: false,
            visible: true,
            items: [
              {
                label: i18n.t("common.gateways"),
                icon: "fa-solid fa-tower-broadcast",
                url: `/organizations/${organizationId}/sites/${siteId}/assets/gateways/`,
                namespace: `/organizations/${organizationId}/sites/${siteId}/assets/gateways/`,
                disabled: false,
                visible: true
              },
              {
                label: i18n.t("common.communication"),
                icon: "fa-solid fa-podcast",
                url: `/organizations/${organizationId}/sites/${siteId}/assets/communication/networks/`,
                namespace: `/organizations/${organizationId}/sites/${siteId}/assets/communication/`,
                disabled: false,
                visible: true
              },
              {
                label: i18n.t("common.building"),
                icon: "fa-regular fa-building",
                url: `/organizations/${organizationId}/sites/${siteId}/assets/building/spaces/`,
                namespace: `/organizations/${organizationId}/sites/${siteId}/assets/building/`,
                disabled: false,
                visible: true
              }
            ]
          },
          {
            slug: "connectivity",
            label: i18n.t("common.connectivity"),
            icon: "fa-solid fa-wifi",
            url: `/organizations/${organizationId}/sites/${siteId}/connectivity/`,
            disabled: false,
            visible: false
          },
          {
            slug: "optimization",
            label: i18n.t("common.optimization"),
            icon: "fa-solid fa-gears",
            url: `/organizations/${organizationId}/sites/${siteId}/optimization/`,
            disabled: false,
            visible: true,
            items: [
              {
                label: i18n.t("common.states"),
                icon: "fa-solid fa-gears",
                namespace: `/organizations/${organizationId}/sites/${siteId}/optimization/states/`,
                url: `/organizations/${organizationId}/sites/${siteId}/optimization/states/`,
                disabled: false,
                visible: true
              },
              {
                label: i18n.t("common.edge_controller"),
                icon: "fa-solid fa-gear",
                namespace: `/organizations/${organizationId}/sites/${siteId}/optimization/edge-controllers/`,
                url: `/organizations/${organizationId}/sites/${siteId}/optimization/edge-controllers/`,
                disabled: false,
                visible: true
              }
            ]
          },
          {
            label: i18n.t("common.operations"),
            icon: "fa-solid fa-shuffle",
            namespace: `/organizations/${organizationId}/sites/${siteId}/operations/`,
            url: `/organizations/${organizationId}/sites/${siteId}/operations/space-constraints`,
            disabled: false,
            visible: true
          },
          {
            slug: "events",
            label: i18n.t("common.events"),
            icon: "fa-solid fa-bell",
            namespace: `/organizations/${organizationId}/sites/${siteId}/events/`,
            url: `/organizations/${organizationId}/sites/${siteId}/events/`,
            disabled: false,
            visible: true
          }
        ]
      }
      break
  }

  return items
}

export default menu
